import styled from 'styled-components';

export const CardsWrapper = styled.div`
  background-color: var(--BackgroundGrey);
  height: 100vh;
`;

export const CardsContainer = styled.div`
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  margin: 0 90px;
  display: grid;
`;

export const TeamsCard = styled.div`
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.02);
  border: 1px solid #f0f0f0;
  background-color: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  cursor: pointer;
  width: 270px;
`;

export const TeamsCardHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TeamsCardHeaderExport = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 12px 12px;
`;

export const TeamsCardHeaderExportSpan = styled.span`
  color: var(--DarkGray);
  font-weight: 500;
  font-size: 12px;
`;

export const TeamsCardFront = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TeamsCardFrontTitle = styled.span`
  color: var(--DarkGray);
  font-weight: 500;
  margin-top: 5px;
  font-size: 18px;
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TeamsCardFrontSubtitle = styled.span`
  color: #5d6c76;
  font-weight: 400;
  font-size: 12px;
`;

export const TeamsCardMiddle = styled.div`
  bottom: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  position: relative;
`;

export const TeamsCardMiddleLine = styled.div`
  background-color: var(--LightGray);
  width: 90px;
  height: 1px;
`;

export const TeamsCardMiddleWrapper = styled.div`
  border: 1px solid var(--LightGray);
  background-color: #fcfcfd;
  border-radius: 17px;
  padding: 3px 18px;
  display: flex;
`;

export const TeamsCardMiddleWrapperSpan = styled.span`
  display: inline-block;
  width: max-content;
  font-size: 9px;
  color: #5d6c76;
`;

export const TeamsCardFooter = styled.div`
  background-color: rgba(247, 248, 250, 0.22);
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
`;

export const TeamsCardFooterItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TeamsCardFooterBadge = styled.div`
  background-color: #f6f6f6;
  justify-content: flex-start;
  align-items: center;
  border-radius: 17px;
  min-width: 110px;
  display: flex;
  margin: 5px 0;
`;

export const TeamsCardFooterBadgeItem = styled.span`
  margin: 5px;
`;

export const TeamsCardFooterBadgeSpan = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: #5d6e81;
`;
